<div class="bg-white rounded mb-3">
  <div class="border-bottom border-2">
    <div class="px-4">
      <h3 class="pt-2">{{ editMode ? "Edit Bill Provider" : "Create Bill Provider" }}</h3>
    </div>
  </div>
  <div class="p-4">
    <form *ngIf="manageBillProviderForm" [formGroup]="manageBillProviderForm">
      <div class="row mb-3">
        <div class="col-md-12">
          <app-image [fieldObject]="controllers['image']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['image'].fieldName)" [isUpdate]="editMode"></app-image>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <app-text [fieldObject]="controllers['name']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['name'].fieldName)" [isUpdate]="editMode">
          </app-text>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary col-auto" type="button" (click)="onSubmit()"
          [disabled]="manageBillProviderForm.invalid">
          Submit
        </button>
      </div>
    </form>
  </div>
</div>
